// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

logoStyles.container = {
    css: css`
        margin: 0;
        display: flex;
        flex-direction: column;
        align-items: start;
        gap: 16px;
        ${xScreen("lte", "xs")} {
            align-items: center;
        }
    `,
};

logoStyles.heading = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
        overflow-wrap: break-word;
        word-wrap: break-word;
    `,
};

logoStyles.image = {
    width: "200px",
    height: "200px",
    css: css`
        display: flex;
        aspect-ratio: 1;

        img {
            aspect-ratio: 1;
        }
    `,
};
